export default "__VITE_ASSET__0f124b9d__"